import * as React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Clock } from "lucide-react";
import Pagination from "./Pagination";
import AttendanceFilter from "./Attendance/AttendanceFilter";
import AttHistoryTable from "./Attendance/AttHistoryTable";

const AttendanceHistory = () => {
  const [filteredData, setFilteredData] = React.useState([]);
  return (
    <div className="max-w-6xl mx-auto p-4 md:p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-foreground mb-2">
          Attendance History
        </h1>
        <div className="text-sm text-muted-foreground flex items-center gap-2">
          <Clock size={16} />
          Last Updated:
          {filteredData.length
            ? new Date(filteredData[0]?.updatedAt).toLocaleTimeString()
            : "Loading..."}
        </div>
      </div>

      <AttendanceFilter setFilteredData={setFilteredData} />

      {/* Attendance Table */}
      <Card>
        <CardContent className="p-4">
          <div className="overflow-x-auto">
            <Pagination data={filteredData} itemsPerPage={10}>
              {(paginatedData) => <AttHistoryTable data={paginatedData} />}
            </Pagination>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AttendanceHistory;
